import dayjs from 'dayjs'
import 'dayjs/locale/th'
import buddhistEra from 'dayjs/plugin/buddhistEra'

dayjs.locale('th')
dayjs.extend(buddhistEra)

export const getDate = (date: string, format: string) => {
  return dayjs(date).format(format)
}

export const getMonth = () => {
  const month = dayjs().get('month')
  return dayjs().month(month).format('MMM')
}

export const generatePastMonths = (dateFormat?: string) => {
  const monthsArray = []
  let currentMonth = dayjs() // Get the current month
  for (let i = 0; i < 12; i++) {
      monthsArray.unshift(currentMonth.format(dateFormat || 'MMM BBBB')) // Format the month as "Month Year" (e.g., "March 2024") and add to the beginning of the array
      currentMonth = currentMonth.subtract(1, 'month') // Move to the previous month
  }
  return monthsArray.reverse()
}

export const getLast12Month = () => {
  const date = new Date()
  const originalDate =  new Date(
    date.getFullYear(),
    date.getMonth() - 11
  )
  return dayjs(originalDate).format('MMM')
}

export function formatMonthYearToBangkokEn(isoString: string): string {
  const date = new Date(isoString)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Bangkok'
  }).format(date)
}

export const DATE_FORMAT = 'DD MMM BB'
export const DateFormat = 'DD MMM BBBB'

export type DateStatus =
  | 'inactive'       // flag off
  | 'scheduled'      // flag on but before startDate
  | 'active'         // flag on and within window
  | 'expired'        // flag on but after endDate
export const getDateStatus = (startDate: string | null, endDate: string | null): DateStatus => {
  const now = new Date()

  if (!startDate || !endDate) return 'inactive'

  const start = startDate ? new Date(startDate) : null
  const end   = endDate   ? new Date(endDate)   : null

  if (start && now < start) return 'scheduled'
  if (end   && now > end)   return 'expired'
  return 'active'
}